






















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { PostColor } from 'types'
import { oldPostColorRgb, postApprovalColorRgb, postColorRgb, RGB, RGBA } from 'bits/post_color'

@Component({})
class SurfacePopupWithTip extends Vue {
  @Prop({ type: String, default: null }) color!: PostColor | 'forced_white'
  @Prop({ default: false }) shouldMatchApprovalColor!: boolean
  @Getter isUsingNewComposerModal!: boolean
  @Getter isUsingNewSurfaceShadows!: boolean
  @Getter colorScheme!: 'light' | 'dark'

  get isLightColorScheme(): boolean {
    return this.colorScheme === 'light'
  }

  get tipColor(): string {
    // some times we force the tip to be white, e.g. for map format pin drop suggestion
    if (this.color === 'forced_white') {
      return 'rgb(255, 255, 255)'
    }
    if (this.shouldMatchApprovalColor) {
      return this.parseColorToRgbString(
        postApprovalColorRgb({
          postColor: this.color,
          isLightColorScheme: this.isLightColorScheme,
        }),
      )
    }
    return this.parseColorToRgbString(
      this.isUsingNewComposerModal
        ? postColorRgb({
            postColor: this.color,
            isLightColorScheme: this.isLightColorScheme,
          })
        : oldPostColorRgb({
            postColor: this.color,
            isLightColorScheme: this.isLightColorScheme,
          }),
    )
  }

  parseColorToRgbString(color: RGB | RGBA): string {
    return `rgb(${color.r}, ${color.g}, ${color.b})`
  }
}
export default SurfacePopupWithTip
